'use client';
import { TailwindBreakPoints } from '@src/typescriptGlobals/types';
import { RootStateTypes, useTypedAppSelector } from '@src/redux/store/store.types';

const useBreakpoint = () => {
  const { width } = useTypedAppSelector((state: RootStateTypes) => state.windowRXS);

  return {
    isMobile: width < TailwindBreakPoints.md,
    isTablet: width >= TailwindBreakPoints.md && width < TailwindBreakPoints.lg,
    isDesktop: width >= TailwindBreakPoints.lg,
  };
};
export default useBreakpoint;
